export default "__VITE_ASSET__BEdkG2Tx__"